import React from 'react'

import AdTag from '@/components/adtag/AdTag';
import AppHeader from "@/components/header/AppHeader";

function Import() {
    return (
        <div className="import app-page">
            <AppHeader title="Управление рекламными тегами" />

            <div className="app-container">
                <AdTag />
            </div>
        </div>
    )
}

export default Import